var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82516 43.9399C4.49889 49.8836 9.5251 54.5178 15.5031 54.73C18.5355 54.8376 21.6492 54.8932 25.0051 54.8932C28.361 54.8932 31.4747 54.8376 34.5071 54.73C40.4851 54.5178 45.5113 49.8836 46.1851 43.9399C46.4199 41.8682 46.5825 39.7633 46.5825 37.6313C46.5825 35.4992 46.4199 33.3944 46.1851 31.3227C45.5113 25.379 40.4851 20.7447 34.5071 20.5326C31.4747 20.425 28.361 20.3694 25.0051 20.3694C21.6492 20.3694 18.5355 20.425 15.5031 20.5326C9.5251 20.7447 4.49889 25.379 3.82516 31.3227C3.59033 33.3944 3.42773 35.4992 3.42773 37.6313C3.42773 39.7633 3.59033 41.8682 3.82516 43.9399Z",
    fill: "#84C70D",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82516 43.9399C4.49889 49.8836 9.5251 54.5178 15.5031 54.73C18.5355 54.8376 21.6492 54.8932 25.0051 54.8932C28.361 54.8932 31.4747 54.8376 34.5071 54.73C40.4851 54.5178 45.5113 49.8836 46.1851 43.9399C46.4199 41.8682 46.5825 39.7633 46.5825 37.6313C46.5825 35.4992 46.4199 33.3944 46.1851 31.3227C45.5113 25.379 40.4851 20.7447 34.5071 20.5326C31.4747 20.425 28.361 20.3694 25.0051 20.3694C21.6492 20.3694 18.5355 20.425 15.5031 20.5326C9.5251 20.7447 4.49889 25.379 3.82516 31.3227C3.59033 33.3944 3.42773 35.4992 3.42773 37.6313C3.42773 39.7633 3.59033 41.8682 3.82516 43.9399Z",
    stroke: "#84C70D",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0944 20.3691V15.1905C37.0944 11.9858 35.8213 8.91237 33.5553 6.6463C31.2892 4.38024 28.2158 3.10718 25.0111 3.10718C21.8064 3.10718 18.7329 4.38024 16.4669 6.6463C14.2008 8.91237 12.9277 11.9858 12.9277 15.1905V20.3691",
    stroke: "#84C70D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9989,
    cy: 37.6317,
    r: 5.17857,
    fill: "#84C70D",
    stroke: "#84C70D",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.487fe67700bfeacc2adf4e3ccbc95543.svg";
export { ForwardRef as ReactComponent };